import CssBaseline from "@mui/material/CssBaseline";
import { Grid, Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import networkLines from "../images/network-lines.svg";
import { PropsWithChildren } from "react";
import json2mq from 'json2mq';
import useMediaQuery from '@mui/material/useMediaQuery';

interface AuthLayoutProps extends PropsWithChildren {
  sideContent: React.ReactNode;
}

const AuthPage = (props: AuthLayoutProps) => {
  const tallWindow = useMediaQuery(
    json2mq({
      minHeight: 700,
    })
  );

  const backgroundArtStyle = tallWindow ? {
    transition: 'opacity 0.5s',
    zIndex: 0,
    position: "fixed",
    bottom: '-5vh',
    left: "-10vw",
    width: "110vw",
    backgroundPosition: "center",
    backgroundImage: `url(${networkLines})`,
    backgroundSize: "cover",
    height: "60vh",
    opacity: 1
  } : {
    transition: 'opacity 0.5s',
    zIndex: 0,
    position: "fixed",
    bottom: '-20vh',
    left: "-10vw",
    width: "110vw",
    backgroundPosition: "center",
    backgroundImage: `url(${networkLines})`,
    backgroundSize: "cover",
    height: "60vh",
    opacity: 0.5
  }

  const backgroundGradientStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    background: `radial-gradient(circle at bottom right,#2B1040,transparent), linear-gradient(to right,#04041E,#111264)`,
    backgroundColor: "#111264",
  }

  return (
    <Box
      component="main"
      sx={{
        position: "relative",
        padding: tallWindow ? "10vh 32px" : "2rem",
        flexDirection: "column",
      }}
    >
      <Box sx={backgroundGradientStyle} />
      <Box sx={backgroundArtStyle} />
      <CssBaseline />
      <Grid container sx={{ maxWidth: 960, margin: "auto", position: "relative", zIndex: 2 }}>
        <Grid item xs={12} sm={5}>
          {props.sideContent}
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          md={7}
          component={Paper}
          elevation={1}
        >
          <Box
            sx={{
              my: { xs: 2, sm: 4 },
              mx: { xs: 2, sm: 4 },
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
            }}
          >
            {props.children}
          </Box>
        </Grid>
      </Grid>
    </Box >
  )
}

export default AuthPage;
